module.exports = __webpack_public_path__ + "img/checked1.85ea63fb.svg";